import z from "zod";

export const publicPaymentSuccessDataSchema = z.object({
  paymentId: z.string(),
  amount: z.number(),
  previousPayments: z.array(
    z.object({
      amount: z.number(),
      date: z.string(),
      paymentId: z.string(),
    })
  ),
  contractValue: z.number(),
  totalPaid: z.number(),
});

export type PublicPaymentSuccessData = z.infer<typeof publicPaymentSuccessDataSchema>;